export default __webpack_public_path__ + "static/media/sport__hero_desktop.fb999f2d.jpg";